import { Box, Typography } from '@material-ui/core'
import { useRef, useState } from 'react'
import ManaWorld from '../../logic/loop/ManaWorld'

import ImportIcon from 'mdi-material-ui/Import'
import ExportIcon from 'mdi-material-ui/Export'
import MGLoader from '../../logic/saves/MGLoader'
import { Dialog } from '@material-ui/core'
import GameGlobals from '../Game/GameGlobals'
import ExportDialog from './ExportDialog'
import { IconButton } from '@material-ui/core'

import DotsVerticalIcon from 'mdi-material-ui/DotsVertical'
import { Menu } from '@material-ui/core'
import { MenuItem } from '@material-ui/core'
import { ListItemIcon } from '@material-ui/core'

export default function ImportExport({ manaWorld = undefined as (undefined | ManaWorld) }) {

	const [loadError, setLoadError] = useState(false)
	const [showExportDialog, setShowExportDialog] = useState(false)
	const [showMenu, setShowMenu] = useState(false)

	const buttonRef = useRef<any>()

	return (
		<>
			<Box display="flex" justifyContent="center" alignItems="center" marginRight="-16px">
				<IconButton
					color="inherit"
					size="small"
					onClick={(e) => {
						buttonRef.current = e.currentTarget
						setShowMenu(true)
					}}
				>
					<DotsVerticalIcon />
				</IconButton>
			</Box>

			<Menu
				anchorEl={buttonRef.current}
				open={showMenu}
				onClose={() => setShowMenu(false)}
				disableScrollLock
			>
				<MenuItem
					component="label"
				>
					<ListItemIcon><ImportIcon /></ListItemIcon>
					<Typography>Import</Typography>
					<input type="file" hidden accept=".json" onChange={(e) => {
						setShowMenu(false)
						if (manaWorld) {
							const file = e.target?.files?.[0]
							if (file) {
								const fr = new FileReader()
								fr.onload = () => {
									try {
										const json = JSON.parse(fr.result as string)

										// remove old items
										manaWorld.getItems().forEach(item => item.dispose())

										const caster = manaWorld.caster

										// load file
										MGLoader.loadMG(json, caster)

										// reload selected manaworld
										GameGlobals.setSelectedEntity(caster)
									} catch (err) {
										setLoadError(true)
										console.error(err)
									}
								}
								fr.readAsText(file)
							}
						}
					}} />
				</MenuItem>
				<MenuItem
					onClick={() => {
						setShowExportDialog(true)
						setShowMenu(false)
					}}
				>
					<ListItemIcon><ExportIcon /></ListItemIcon>
					<Typography>Export</Typography>
				</MenuItem>
			</Menu>


			{/* export dialog */}
			<ExportDialog open={showExportDialog} onClose={() => setShowExportDialog(false)} onChangeSubmitted={(filename: string) => {
				if (manaWorld) {
					const json = MGLoader.saveMG(manaWorld) as any

					var element = document.createElement('a');
					element.setAttribute('href', 'data:text/json;charset=utf-8,' + encodeURIComponent(json));
					element.setAttribute('download', `${filename}.mg.json`);

					element.style.display = 'none';
					document.body.appendChild(element);

					element.click();

					document.body.removeChild(element);
				}
			}} />

			{/* import error */}
			<Dialog open={loadError} onClose={() => setLoadError(false)}>
				<Box p="1rem">
					Failed to load file
				</Box>
			</Dialog>
		</>
	)
}
